import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AudioView from '../views/Audio.vue'
import VideoView from '../views/Video.vue'
import DatosView from '../views/Datos.vue'
import DomoticaView from '../views/Domotica.vue'
import landingDinamic from '../views/Landing.vue'
import landingTest from '../views/LandingTest.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/audio',
    name: 'audio',
    component: AudioView
  },
  {
    path: '/video',
    name: 'video',
    component: VideoView
  },
  {
    path: '/datos',
    name: 'datos',
    component: DatosView
  },
  {
    path: '/domotica',
    name: 'domotica',
    component: DomoticaView
  },
  {
    path: '/l/:id',
    name: 'landing',
    component: landingDinamic,
    meta: { transition: 'scale', mode: "out-in", requiresAuth: false, title: "Landing" },
  },
  {
    path: '/t/:id',
    name: 'landingTest',
    component: landingTest,
    meta: { transition: 'scale', mode: "out-in", requiresAuth: false, title: "Landing Test" },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
